import { ApolloClient, InMemoryCache } from "@apollo/client"
import fetch from "isomorphic-fetch"

const defaultOptions = {
  watchQuery: {
    fetchPolicy: "no-cache",
  },
  query: {
    fetchPolicy: "no-cache",
  },
}

const getApiUri = () => {
  const baseUrl = process.env.GATSBY_SINGITA_API || `http://localhost:4000`
  // If the URL already ends with /graphql, don't append it again
  return baseUrl.endsWith('/graphql') ? baseUrl : `${baseUrl}/graphql`
}

export const client = new ApolloClient({
  uri: getApiUri(),
  fetch,
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions,
})
